import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { HelpText, Icon, Qmark, Wrapper } from './FormHelpLabel.style'

const FormHelpLabel = ({ children }) => {
  const [textWidth, setTextWidth] = useState('none')

  const findSection = (el) => {
    const { parentNode: parent } = el
    let section = el
    if (['section', 'SECTION'].indexOf(parent.tagName) > -1) {
      section = parent
    } else if (parent.parentNode) {
      section = parent.parentNode && findSection(parent)
    }
    return section
  }

  const handleHover = ({ currentTarget }) => {
    const { left } = currentTarget.getBoundingClientRect()
    const section = findSection(currentTarget)
    const { left: secLeft } = section.getBoundingClientRect()
    setTextWidth(`${section.clientWidth - left + secLeft + 16}px`)
  }

  return (
    <Wrapper onMouseOver={handleHover} onFocus={handleHover}>
      <Icon>
        <Qmark>?</Qmark>
      </Icon>
      <HelpText maxWidth={textWidth}>{children}</HelpText>
    </Wrapper>
  )
}

FormHelpLabel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

FormHelpLabel.defaultProps = {
  children: null,
}

export default FormHelpLabel
